module.exports = __webpack_public_path__ + "img/down-big-img.png";